/**
 *  Select script file
**/

export default {
  name: 'app-select',
  mixins: [],
  components: {},
  props: {
    data: {
      type: Array,
      required: true
    },
    selected: {
      type: Object,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: 'primary'
    }
  },
  data () {
    return {
      selectedItem: null
    }
  },
  mounted () {
    this.selectedItem = this.selected
  },
  computed: {
  },
  methods: {
    set (item) {
      if (this.selectedItem === undefined || this.selectedItem.id !== item.id) {
        this.$refs.dropdown.open = false
      }

      this.selectedItem = item
      this.$emit('select', this.selectedItem)
    }
  }
}
